<template>
  <div class="shopPreset">
    <div class="presetBox">
      <PresetOption
        class="presetItem"
        ref="preset_option"
        :locale="locale"
        @deletePreset="deletePreset" />
      <PresetAvailableTime
        class="presetItem"
        ref="preset_availableTime"
        :locale="locale"
        @deletePreset="deletePreset" />
      <PresetPromotion
        class="presetItem"
        ref="preset_promotion"
        :locale="locale"
        @deletePreset="deletePreset" />
      <PresetStatus
        class="presetItem"
        ref="preset_status"
        :locale="locale"
        @deletePreset="deletePreset" />
      <PresetDetails
        class="presetItem"
        ref="preset_details"
        :locale="locale"
        @deletePreset="deletePreset" />
      <!-- <PresetCustomField
        class="presetItem"
        :locale="locale" /> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LANG from '@/common/lang'
import regExp from '@/common/regExp'
import PresetOption from './ShopPresetOption'
import PresetAvailableTime from './ShopPresetAvailableTime'
import PresetPromotion from './ShopPresetPromotion'
import PresetStatus from './ShopPresetStatus'
import PresetDetails from './ShopPresetDetails'
import PresetCustomField from './ShopPresetCustomField'

export default {
  name: 'ShopPreset',
  props: [
    'locale'
  ],
  components: {
    PresetOption,
    PresetAvailableTime,
    PresetPromotion,
    PresetStatus,
    PresetDetails,
    PresetCustomField
  },
  computed: {
    defaultLang () {
      const langInfo = this.$store.state.setting.lang
      return langInfo.default
    },
    getShopResultData () {
      return this.$store.getters['shop/getShopResultData']
    }
  },
  created () {
    this.init()
  },
  mounted () {
  },
  data () {
    return {
    }
  },
  methods: {
    async init () {

    },
    async checkUsePreset(presetId) {
      try {
        const res = await this.$store.dispatch('shop/checkUseStorePreset', presetId)
        const useItems = (res && res.message && res.message.useShopItems) || []
        if (useItems.length > 0) {
          const useItemNames = useItems.map(x => x.shopItemName[this.defaultLang]).join(', ')
          return confirm(`${useItems.length}개의 상품에서 이 프리셋을 설정 중입니다.\n이대로 삭제하시겠습니까?\n(${useItemNames})`)
        }
        return confirm(this.locale.confirm_delete_preset) // 사용 중인 상품이 없으면 바로 삭제 진행 가능
      } catch (error) {
        console.error('checkUsePreset error:', error)
        return false
      }
    },
    async deletePreset(presetType, presetId) {
      const isConfirmed = await this.checkUsePreset(presetId)
      if (isConfirmed) {
        const res = await this.$store.dispatch('shop/delShopPreset', presetId)
        if (res && res.status === 200) {
          alert(this.locale.complete_delete)
          if (this.$refs[`preset_${presetType}`]) {
            this.$refs[`preset_${presetType}`].getPresetList()
          }
        } else {
          const status = (res && res.message && res.message.code) || 500
          const message = this.getShopResultData(status)
          alert(message)
        }
      }
    }
  }

}
</script>
